{{each list}}
<li>
    <a href="/user/index?uid={{$value.id}}">
        <span><img src="{{$value.avatar}}" alt=""></span>
        <p class="title">{{$value.value}}</p>
        <p class="desc">{{$value.org}}</p>
    </a>
    <button class="follow-skin  _beFriend"  data-id="{{$value.id}}">加好友</button>
</li>
{{/each}}